<template>
  <div class="select-box" :class="{invisible:!visible}">
    <div class="select-item" v-for="(item, index) in selections" :key="index" :class="(index == selectedIndex)?'selected':''" @click.stop="itemClick(item)">{{ item.label }}</div>

  </div>
</template>

<script>
export default {
  name: "SelectBox",
  props: {
    selections: {
      type: Array,
      default: function(){
        return [];
      }
    },

    selection: {
      default: 0
    },
  },

  data: function(){
    return {
      visible: false,
      globalClickEnabled: false
    }
  },

  methods: {
    detectGlobalClick: function(){

      if(this.globalClickEnabled){
        console.log("global click");

        this.visible = false;
        this.removeGlobalClick();

      }
    },

    removeGlobalClick: function(){
      window.removeEventListener("click", this.detectGlobalClick);
      this.globalClickEnabled = false;
    },

    itemClick: function(item){
      if(!this.visible){
        this.visible = true;
        window.addEventListener("click", this.detectGlobalClick);
        this.globalClickEnabled = true;
      }else{
        if(item.label == this.selections[this.selectedIndex].label){
          this.visible = false;
        }
        this.$emit("select", item.tgt);


      }

    }
  },

  computed: {
    selectedIndex: function(){
      if(this.selections.length){
        if(isNaN(this.selection)){
          if(this.selection){
              return this.selections.findIndex((item) => {
                return (item.label == this.selection)
              })
          }
        }

      }
      return this.selection;
    }
  }


}
</script>

<style scoped>
  .select-box.invisible {
    padding-bottom: 0;
    background-color: transparent;
    box-shadow: none;
  }

  .select-box.invisible .select-item {
    display: none;
  }

  .select-box.invisible .select-item.selected {
    opacity: 0;
    display: block;
  }

  .select-box {
    position: absolute;
    background-color: white;
    user-select: none;
    box-shadow: 0 1px 2px rgba(0,0,0,0.3);
    padding-bottom: 1em;

  }

  .select-item {
    padding: 1em;
    padding-right: 2em;
    color: black;
    cursor: pointer;

  }



  .select-item.selected {
    color: #008CF2;
    background-color: #E5F0F7;
  }
</style>